module.exports = __webpack_public_path__ + "img/p2_box2.2997bd8c.jpg";